import wa from 'apps/analytics/services/waEventEmitter';
import pageTypes from 'apps/analytics/utils/pageTypes';
import pageEventTypes from 'apps/analytics/utils/pageEventTypes';
import { getBrowserStats } from 'apps/analytics/utils/statsProviders';
import sendAdvertAnalytics from 'apps/analytics/utils/sendAdvertAnalytics';
import routeMonitor from 'utils/routeMonitor';
import componentFields from 'apps/analytics/utils/componentFields';
import componentTypes from 'apps/analytics/utils/componentTypes';
import containerTypes from 'apps/analytics/utils/containerTypes';
import pageViewIdGenerator from 'apps/analytics/utils/pageViewIdGenerator';
import { setNewPageViewId } from 'apps/analytics/actions/analytics';
import { hasLocationChanged, hasLocationUrlChanged } from 'apps/analytics/utils/analyticLocationComparator';

export {
  wa,
  pageTypes,
  pageEventTypes,
  getBrowserStats,
  sendAdvertAnalytics,
  routeMonitor,
  componentFields,
  componentTypes,
  containerTypes,
  pageViewIdGenerator,
  setNewPageViewId,
  hasLocationChanged,
  hasLocationUrlChanged,
};
